// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel_carousel__h6FTM","content":"carousel_content__W3ffb","control":"carousel_control__1vSvG"};